import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import SignInForm from './Component/JSX/loginForm/loginForm';
import LandingPage from './Component/JSX/LandingPage/LandingPage';
import SignupForm from './Component/JSX/SignupForm/SignupForm';
import Dashboard from './Component/JSX/Dashboard/Dashboard';
import LatestRequest from './Component/JSX/LatestRequest/LatestRequest';
import LatestProperties from './Component/JSX/LatestProperties/LatestProperties';
import Profile from './Component/JSX/Profile/Profile';
import Setting from './Component/JSX/Setting/Setting'
import { ToastContainer } from 'react-toastify';  
import CreateOffer from './Component/JSX/CreateOffer/CreateOffer';
import PropertyOfferDetail from './Component/JSX/PropertyOfferDetail/PropertyOfferDetail';
import AllUsers from './Component/JSX/AllUsers/AllUsers';
import LatestRequestDetail from './Component/MyComponents/LatestRequestDetail/LatestRequestDetail';
import Footer from './Component/MyComponents/Footer/Footer';
 

function App() {
  return (
    <Router>
      <div style={{backgroundColor:'white'}} className="App">
        <Routes>
          <Route path="/" element={<SignInForm />} />
          <Route path="/register" element={<SignupForm />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/request" element={<LatestRequest />} />
          <Route path="/properties" element={<LatestProperties />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/setting" element={<Setting />} />
          <Route path="/createOffer" element={<CreateOffer />} />
          <Route path="/allusers" element={<AllUsers />} />
          <Route path="/request-detail" element={<LatestRequestDetail />} />


          <Route path="/propertyOfferDetail/:offerId" element={<PropertyOfferDetail />} /> {/* Updated here */}

        </Routes>
        <ToastContainer />
      <Footer/>
      </div>
    </Router>
  );
}

export default App;
